import callAPI from '../ApiConfig'
import $ from "jquery";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const transactionStatuses = async (props) => {

    return await callAPI({
        route: "transaction_statuses/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }

    })

}
const addTransactionStatus = async (props) => {


    return await callAPI({
        route: "transaction_statuses/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })

}
const editTransactionStatus = async (props) => {

    return await callAPI({
        route: "transaction_statuses/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}
const deleteTransactionStatus = async (props) => {


    return await callAPI({
        route: "transaction_statuses/" + props?.data?.id,
        method: "delete",
        signal: props?.signal,
        headers: {

        }
    })
}

const getTransactionStatusList = async (props) => {

    return await callAPI({
        route: "transaction_statuses/",
        method: "get",
        signal: props?.signal,
        params: {
            ...props?.params,
            show_list: 1
        },
        headers: {

        }

    })

}

const transactionStatusAPI = {
    transactionStatuses: transactionStatuses,
    addTransactionStatus: addTransactionStatus,
    editTransactionStatus: editTransactionStatus,
    deleteTransactionStatus: deleteTransactionStatus,
    getTransactionStatusList: getTransactionStatusList
}
export default transactionStatusAPI